import { Navigate, useLocation } from "react-router-dom"

import { isAuthenticated } from "../services/auth"

export const RequireAuth = ({ children }) => {
	const location = useLocation()

	if (!isAuthenticated())
		return <Navigate to="/login" replace state={{ from: location.pathname }} />

	return children
}

export const PublicOnlyRoute = ({ children }) => {
	if (isAuthenticated())
		return <Navigate to="/home" replace />

	return children
}